import DomainTracker from './domain';
import RouteTracker from './routes';
import AdsInteractionTracker from './ads';
import ModalsTracker from './modals';


export const domainTracker = new DomainTracker();
export const routeTracker = new RouteTracker();
export const adsInteractionTracker = new AdsInteractionTracker();
export const modalsTracker = new ModalsTracker();
